/**
 * Measure units machines
 */
export enum UNITS {
  jumbo = 'drillings',
  train = 'loops',
  lhd = 'shelves',
  scoop = 'shelves',
  default = '-'
}
